// extracted by mini-css-extract-plugin
export default {"paddingInput":"POS_paddingInput__jrzfB"};